function formatOrgNumber(orgNumber: string): string;
function formatOrgNumber(orgNumber: string | undefined): string | undefined;
function formatOrgNumber(orgNumber: undefined): undefined;
function formatOrgNumber(orgNumber: string | undefined): string | undefined {
    if (!orgNumber?.length) return orgNumber;
    const _orgNumber = orgNumber.trim();
    switch (_orgNumber.length) {
        case 10:
            return `${_orgNumber.substring(0, 6)}-${_orgNumber.substring(6)}`;
        case 12:
            return `${_orgNumber.substring(2, 8)}-${_orgNumber.substring(8)}`;
        default:
            return _orgNumber;
    }
}

export { formatOrgNumber };
